module.exports = __webpack_public_path__ + "static/media/Tentacle_Introduction_Opening.4d54aa50.mp3";